import { render, staticRenderFns } from "./elevatorList.vue?vue&type=template&id=3af1e498&"
import script from "./elevatorList.vue?vue&type=script&lang=js&"
export * from "./elevatorList.vue?vue&type=script&lang=js&"
import style0 from "./elevatorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports